import React from 'react'

import { AnalyticsCardWrapper } from '../../components/AnalyticsCardWrapper/AnalyticsCardWrapper'
import {
  useAverageOrderValueReportCard,
  useContributionsPerTypeReportCard,
  useConversionRateReportCard,
  usePaymentMethodUsedReportCard,
  useSalesByCountryReportCard,
  useSalesBySourceReportCard,
  useSessionsBySourceReportCard,
  useTopProductsByUnitsSoldReportCard,
  useTotalProfitReportCard,
  useVisitorsReportCard,
} from '../../hooks/reportCards'

export const ShopAnalytics = () => {
  const shopProfitReportCard = useTotalProfitReportCard({
    type: 'shop',
  })
  const shopOrdersReportCard = useContributionsPerTypeReportCard({
    type: 'shop',
  })
  const averageOrderValueReportCard = useAverageOrderValueReportCard()
  const topProductsByUnitsSoldReportCard = useTopProductsByUnitsSoldReportCard()
  const salesByCountryReportCard = useSalesByCountryReportCard()
  const salesByTrafficSourceReportCard = useSalesBySourceReportCard({
    source: 'traffic_source',
  })
  const salesBySocialPlatformReportCard = useSalesBySourceReportCard({
    source: 'social_platform',
  })
  const sessionsByTrafficSourceReportCard = useSessionsBySourceReportCard({
    source: 'traffic_source',
  })
  const sessionsBySocialPlatformReportCard = useSessionsBySourceReportCard({
    source: 'social_platform',
  })
  const visitorsReportCard = useVisitorsReportCard()
  const paymentMethodUsedReportCard = usePaymentMethodUsedReportCard()
  const conversionRatesReportCard = useConversionRateReportCard()

  return (
    <>
      <AnalyticsCardWrapper {...shopProfitReportCard} />
      <AnalyticsCardWrapper {...shopOrdersReportCard} />
      <AnalyticsCardWrapper {...conversionRatesReportCard} />
      <AnalyticsCardWrapper {...visitorsReportCard} />
      <AnalyticsCardWrapper {...averageOrderValueReportCard} />
      <AnalyticsCardWrapper {...topProductsByUnitsSoldReportCard} />
      <AnalyticsCardWrapper {...salesByCountryReportCard} />
      <AnalyticsCardWrapper {...paymentMethodUsedReportCard} />
      <AnalyticsCardWrapper {...salesByTrafficSourceReportCard} />
      <AnalyticsCardWrapper {...sessionsByTrafficSourceReportCard} />
      <AnalyticsCardWrapper {...salesBySocialPlatformReportCard} />
      <AnalyticsCardWrapper {...sessionsBySocialPlatformReportCard} />
    </>
  )
}
